/**
 * @file Build an inline SVG element from a STATIC markup string — the
 * project's icon / logo definitions.
 *
 * Parsed as XML with DOMParser and imported into the page, instead of
 * assigning the string to innerHTML. The app never writes HTML strings into
 * the DOM (every other node is built with el()), so there is no HTML sink an
 * injected value could ever reach. Only ever pass constants, never data.
 */

const parser = typeof DOMParser === 'function' ? new DOMParser() : null;

/** @param {string} markup  a complete `<svg xmlns="http://www.w3.org/2000/svg" …>` document */
export function svgFromMarkup(markup) {
  const doc = parser.parseFromString(markup, 'image/svg+xml');
  const root = doc.documentElement;
  if (!root || root.nodeName !== 'svg' || doc.querySelector('parsererror')) {
    throw new Error('svgFromMarkup: invalid SVG markup');
  }
  return document.importNode(root, true);
}

/** The standard's icon / logo markup omits the namespace (it's meant for
 *  innerHTML); add it so the XML parse yields a real SVG element. */
export function svgFromStandard(markup) {
  return svgFromMarkup(markup.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" '));
}
